import logo from 'assets/icons/logo.svg';
import logoDark from 'assets/icons/logo-dark.svg';
import { useSelector } from 'react-redux';
import { IRootReducerState } from 'store/store';
import { Container, Content, LogoWrapper, Logo, Label } from './Wrapper.styled';

interface IWrapperProps {
  title: string;
  children: React.ReactNode;
}

const Wrapper = ({ title, children }: IWrapperProps) => {
  const { darkMode } = useSelector(
    (state: IRootReducerState) => state.commonInfo
  );

  return (
    <Container>
      <Content>
        <LogoWrapper>
          <Logo src={darkMode ? logoDark : logo} alt="" />
        </LogoWrapper>
        <Label>{title}</Label>
        <>{children}</>
      </Content>
    </Container>
  );
};

export default Wrapper;
